import { OpenHideEffekt } from "../../common/openHideEffekt";
import { ReloadManager } from "../reloadManager";

/**
 * Funktionen fuer das Tariflist CmsModul
 *  - Filter ein und ausblenden
 */
export class Tariflist {
    private readonly viewRoot: HTMLElement;
    private readonly reloadManager: ReloadManager;

    constructor(viewRoot: HTMLElement) {
        this.viewRoot = viewRoot;
        this.reloadManager = new ReloadManager();
        this.registerEventListeners();
    }

    private registerEventListeners(): void {
        this.submitListenersByOrderByFilter();
        this.moreFilterListener();
        this.moreFilterPhoneListener();
        this.showMoreTariffsListener();
        this.resetFilterListeners();
        this.resetFilterListenersByOneItem();
    }

    /**
     *  beim Sortieren der Liste wird ein submit ausgefuehrt
     */
    private submitListenersByOrderByFilter(): void {
        const filterForm: HTMLFormElement | null = this.viewRoot.querySelector(
            "form.form_moduleCms_tariflist",
        );
        filterForm?.addEventListener("submit", (event) => {
            event.preventDefault();
            this.reloadManager.reloadModule(filterForm);
        });
    }

    /**
     *  die Tarifliste hat einen Button um weitere Filter aufzuklappen
     */
    private moreFilterListener(): void {
        const moreFilters: NodeListOf<HTMLElement> =
            this.viewRoot.querySelectorAll(
                ".moduleCms_tariflist .more-filters",
            );
        moreFilters.forEach((moreFilterElement) => {
            moreFilterElement.addEventListener("click", (event) => {
                event.preventDefault();

                const moduleRoot = moreFilterElement.closest(
                    ".cms-module-root",
                ) as HTMLElement;
                if (!moduleRoot) {
                    return;
                }

                const hiddenFilterContainer = moduleRoot.querySelector(
                    ".cms-tarif-list-filter .drop-panel",
                ) as HTMLDivElement;
                if (!hiddenFilterContainer) {
                    return;
                }

                const openHideEffekt = new OpenHideEffekt();
                if (!hiddenFilterContainer.classList.contains("active")) {
                    openHideEffekt.slideDown(hiddenFilterContainer);
                    moduleRoot.classList.add("active");
                    hiddenFilterContainer.classList.toggle("active");
                    moreFilterElement.innerHTML =
                        "<span>Filter anwenden</span>";
                } else {
                    openHideEffekt.slideUp(hiddenFilterContainer);
                    moduleRoot.classList.remove("active");
                    hiddenFilterContainer.classList.toggle("active");
                    const isVvl = moduleRoot.getAttribute("data-isVvl");
                    if (isVvl) {
                        moreFilterElement.innerHTML = "<span>Filter</span>";
                    } else {
                        moreFilterElement.innerHTML =
                            "<span>Mehr Filter</span>";
                    }
                }
            });
        });
    }

    /**
     *  die Tarifliste hat im Phone-Viewport einen Button um weitere Filter aufzuklappen
     */
    private moreFilterPhoneListener(): void {
        const moreFiltersPhone: NodeListOf<HTMLElement> =
            this.viewRoot.querySelectorAll(
                ".moduleCms_tariflist .more-filters-mobile",
            );
        moreFiltersPhone.forEach((moreFilterElement) => {
            moreFilterElement.addEventListener("click", (event) => {
                event.preventDefault();
                const moduleRoot = moreFilterElement.closest(
                    ".cms-module-root",
                ) as HTMLElement;
                if (!moduleRoot) {
                    return;
                }
                const overlayArea = moduleRoot.querySelector(
                    ".cms-tarif-list-filter",
                ) as HTMLDivElement;
                if (!overlayArea) {
                    return;
                }
                const hiddenFilterContainer = overlayArea.querySelector(
                    ".drop-panel",
                ) as HTMLDivElement;
                if (!hiddenFilterContainer) {
                    return;
                }

                if (!hiddenFilterContainer.classList.contains("active")) {
                    hiddenFilterContainer.style.display = "block";
                    hiddenFilterContainer.classList.toggle("active");
                    overlayArea.classList.add("mobile-active");
                    moduleRoot.classList.add("active");
                    moreFilterElement.innerHTML =
                        "<span>Filter anwenden</span>";

                    document.body.classList.add("no-scroll");
                    document.documentElement.classList.add("no-scroll");
                } else {
                    hiddenFilterContainer.style.display = "none";
                    hiddenFilterContainer.classList.toggle("active");

                    overlayArea.classList.remove("mobile-active");
                    moduleRoot.classList.remove("active");
                    const isVvl = moduleRoot.getAttribute("data-isVvl");
                    if (isVvl) {
                        moreFilterElement.innerHTML = "<span>Filter</span>";
                    } else {
                        moreFilterElement.innerHTML =
                            "<span>Mehr Filter</span>";
                    }

                    document.body.classList.remove("no-scroll");
                    document.documentElement.classList.remove("no-scroll");
                }
            });
        });
    }

    /**
     * pagination, naechste seite laden
     */
    private showMoreTariffsListener(): void {
        const showMoreItems: NodeListOf<HTMLElement> =
            this.viewRoot.querySelectorAll(
                ".moduleCms_tariflist .showMoreItems",
            );
        showMoreItems.forEach((moreItemsElement) => {
            moreItemsElement.addEventListener("click", (event) => {
                event.preventDefault();
                const moduleRoot = moreItemsElement.closest(
                    ".cms-module-root",
                ) as HTMLElement;
                if (!moduleRoot) {
                    return;
                }

                const form = moduleRoot.querySelector("form");
                if (!form) {
                    return;
                }

                const limitInput: HTMLInputElement | null = form.querySelector(
                    'input[name="limit"]',
                );
                if (!limitInput) {
                    return;
                }
                const currentLimit = parseInt(limitInput.value, 10);
                if (!isNaN(currentLimit)) {
                    limitInput.value = (currentLimit + 6).toString();

                    this.reloadManager.reloadModule(form);
                }
            });
        });
    }

    /**
     *  zum zuruecksetzen ALLER Filter
     */
    private resetFilterListeners(): void {
        const resetFilterItems: NodeListOf<HTMLElement> =
            this.viewRoot.querySelectorAll(
                ".moduleCms_tariflist .reset-filter",
            );
        resetFilterItems.forEach((resetFilterElement) => {
            resetFilterElement.addEventListener("click", (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                let form = resetFilterElement.closest("form");
                if (!form) {
                    // wenn der reset button nicht in einem formular liegt, gehe zu module-root und schaue in dem modul nach einem form
                    const cmsRoot: HTMLElement | null =
                        resetFilterElement.closest(".cms-module-root");
                    form = cmsRoot ? cmsRoot.querySelector("form") : null;
                }

                if (!form) {
                    return;
                }

                form.querySelectorAll("input").forEach((input) => {
                    const cleanFilter = input.dataset.cleanfilter;
                    if (!cleanFilter || cleanFilter !== "no") {
                        input.value = "";
                        input.checked = false;
                    }
                });

                this.reloadManager.reloadModule(form);
            });
        });
    }

    /**
     *  Augewaehlte Filter werden in der Tarifliste als "Quick-Filter"-Badges angezeigt, die man per Klick entfernen kann
     */
    private resetFilterListenersByOneItem(): void {
        const quickFilterItems: NodeListOf<HTMLElement> =
            this.viewRoot.querySelectorAll(
                ".moduleCms_tariflist .quick-filter-item",
            );
        quickFilterItems.forEach((quickFilterItem) => {
            quickFilterItem.addEventListener("click", (event) => {
                event.preventDefault();
                event.stopImmediatePropagation();

                //The class because of equal items in different viewports
                const filterIdentifier = quickFilterItem.dataset.id;
                if (!filterIdentifier) {
                    return;
                }

                const moduleRoot = quickFilterItem.closest(
                    ".cms-module-root",
                ) as HTMLElement;
                if (!moduleRoot) {
                    return;
                }

                const input: HTMLInputElement | null = moduleRoot.querySelector(
                    `input[data-filter-identifier="${filterIdentifier}"]`,
                );
                if (!input) {
                    return;
                }

                if (input.type === "checkbox") {
                    input.checked = false;
                } else {
                    input.value = "";
                }

                const form = quickFilterItem.closest("form");
                if (!form) {
                    return;
                }

                this.reloadManager.reloadModule(form);
            });
        });
    }
}
